<template>
    <div id="erweimaShare">
        <Headers :headersText='headersText'></Headers>
        
        <div class="bgs">
            <div id="qrcode" ref="qrcode"><img :src="erweimaLink" style="width:100%" alt=""></div>
            <div class="text">
                <div>扫一扫&emsp;立马下载钱大师</div>
                <div>用户{{userName}}邀请您加入钱大师</div>
            </div>
        </div>

        <!-- <div class="btn" @click="saveEWM">保存二维码</div> -->

        <div class="tips">长按上方二维码进行保存</div>

        <popup :pops='pops' @fatherMethod='fatherMethod' v-show="saveEWMs"></popup>
    </div>
</template>

<script>
    // 引入 二维码生成
    import QRCode from 'qrcodejs2'
    // 引入弹窗
    import popup from '../components/Popup.vue'

    import Headers from '../components/headers'
    export default {
        components:{
            popup,
            Headers
        },
        data() {
            return {
                headersText:'您的分享二维码',
                pops:{
                    icons:require('../assets/images/img_62.png'), //可选
                    iconWidth:82, // 可选（若有图片必填）
                    iconHeight:81, // 可选（若有图片必填）
                    tits1:'二维码已保存至相册', // 可选
                    tits2:'快去分享给小伙伴吧', // 可选
                    // conts:'任务完成任务完成任务完成任务完成任务完成任务完成', // 可选
                    btns:'确定',
                    btnMarginTop:10
                },
                saveEWMs:false,
                userName:'', // 用户昵称
                inviteCode:null, // 邀请码
                webSeverDomain: '', // web服务器域名
                erweimaLink: '', // 二维码链接
            }
        },
        created() {
            this.init();
        },
        mounted() {
            
        },
        methods: {
            // 初始化 接口调用
            init(){
                this.$loading(true);
                // 个人中心
                this.$http.GETS('User/userCenter',{},(res)=>{
                    this.$loading(false);
                    console.log(res.data.invite_code);
                    this.userName = res.data.name;
                    this.erweimaLink = res.data.invite_img;
                    this.inviteCode = res.data.invite_code;

                    /* 取消前端生成二维码 */
                    // this.webSeverDomain = localStorage.getItem('webServerDomain');
                    // this.qrcode();
                });
            },
            // 生成二维码
            qrcode () {  
                let _this = this;
                let qrcode = new QRCode('qrcode', {  
                    width: 52,  
                    height: 52, // 高度  [图片上传失败...(image-9ad77b-1525851843730)]
                    text: _this.webSeverDomain + '/#/share?inviteCode=' + _this.inviteCode // 二维码内容  
                    // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）  
                    // background: '#f0f'  
                    // foreground: '#ff0'  
                })
            },
            // 保存二维码
            saveEWM:function(){
                this.saveEWMs = true;
            },
            // 子组件方法
            fatherMethod:function(){
                this.saveEWMs = false
                this.$router.push('/');
            }
        },
    }
</script>

<style lang="less" scoped>
    #erweimaShare{
        .bgs{
            width: 335px;
            height: 417px;
            background-image: url('../assets/images/img_54.png');
            background-repeat: no-repeat;
            background-size: 100% 100%;
            margin: 20px;
            position: relative;
            #qrcode{
                width: 52px;
                height: 52px;
                position: absolute;
                bottom: 28px;
                left: 30px;
                padding: 5px;
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.1);
            }
            .text{
                width: 55%;
                position: absolute;
                bottom: 40px;
                left: 112px;
                div{
                    &:nth-of-type(1){
                        font-size: 15px;
                        font-weight: bold;
                    }
                    &:nth-of-type(2){
                        margin-top: 3px;
                        font-size: 12px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
        .btn{
            width:335px;
            height:50px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
            border-radius:25px;
            font-size:15px;
            color:rgba(255,255,255,1);
            text-align: center;
            line-height: 50px;
            margin: 0 20px;
        }

        .tips{
            text-align: center;
            font-size: 16px;
            color: #999999;
            text-decoration: underline;
            padding-bottom: 15px;
        }
    }
</style>